
export async function getTerminalAddress(spi) {
  return new Promise((resolve) => {
    spi.GetTerminalAddress().then((result) => {
      resolve(result);
    });
  });
}
